import React from "react";

import { accountContent, sectionHeader, sectionHeaderTitle, sectionHeaderDescription } from "./pass-change.module.scss";

import PassChangeForm from "../../auth/forms/pass-change-form";

export default function PassChange() {
    return (
        <div className={accountContent}>
            <div className={sectionHeader}>
                <div>
                    <h1 className={sectionHeaderTitle}>Zmiana hasła</h1>
                    <p className={sectionHeaderDescription}>
                        Zadbaj o bezpieczeństwo swojego konta.
                    </p>
                </div>
            </div>
            <PassChangeForm />
        </div>
    );
}
